import { createContext, Dispatch, SetStateAction } from 'react'

import { SpecialLocationsForm } from '../types'

export const defaultSpecialLocationsForm: SpecialLocationsForm = {
	names: [''],
	geometry: {
		lat: undefined,
		lng: undefined,
	},
}

export const SpecialLocationsFormContext = createContext<{
	specialLocationsForm: SpecialLocationsForm
	setSpecialLocationsForm: Dispatch<SetStateAction<SpecialLocationsForm>>
	formEdited: boolean
	setFormEdited: Dispatch<SetStateAction<boolean>>
	showError: boolean
	setShowError: Dispatch<SetStateAction<boolean>>
}>({
	specialLocationsForm: defaultSpecialLocationsForm,
	setSpecialLocationsForm: () => {},
	formEdited: false,
	setFormEdited: () => {},
	showError: false,
	setShowError: () => {},
})
